<template>
  <div class='signup-info'>
    <common-top :commonTopData="commonTopData" :tableDatas="tableDatas"></common-top>
    <div class='container'>
      <table class="signup-info-table" style="width: 100%" border="0"cellpadding="0" cellspacing="0">
        <tr>
          <th v-for="(item, index) in tableTitle" :key="index" v-text="item"></th>
        </tr>
        <tr v-for="(row, idx) in tableData" :key="idx">
          <td v-for="(col, index) in tableTitle" :key="index">
              <div v-if="row[col]">
                  <img v-if="col === '用户头像'" :src="row[col]" class="user-pic">
                  <span v-if="col === '用户id'">{{ row[col]}}</span>
                  <span v-if="col === '用户昵称'">{{ row[col] }}</span>
                  <span class="text-title"  v-if="row[col].type === 'text'" v-text="row[col].url"></span>
                  <a class="file-title" v-if="row[col].type === 'file'" @click="download(row[col].url, row[col].name)" v-text="row[col].name"></a>
                  <img class="pic-title" v-if="row[col].type === 'pic'" :src="row[col].url" @click="gePicUrl(row[col].url)" alt="图片">
                  <video class="video-title" v-if="row[col].type === 'video'" :src="row[col].url" controls @click="showvideo(item.openId)"></video>
              </div>
          </td>
        </tr>
      </table>
      <!-- 分页 -->
      <el-col :span="24" class="toolbar toolbar-pages">
        <span class="total-num" v-text="`共 ${total} 条数据`"></span>
        <el-pagination
          background
          layout="prev, pager, next, sizes, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :pager-count="11"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          :current-page="currentPage"
          :total="total">
        </el-pagination>
      </el-col>
      <!-- /分页 -->
    </div>
    <!-- 图片放大 -->
    <div class="pic-big" v-if="getPicBig" @click="gePicUrl">
      <span class="mask"></span>
      <img class="pic-big-review" :src="picBig" alt="图片">
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import commonTop from '@/components/commonTop.vue'
import { FileUtils } from '@/common/utils'

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    commonTop
  },
  data () {
    // 这里存放数据
    return {
      tableDatas: [],
      commonTopData: {
					"pageName": "activityEmploy",
					"commonleftbtn": [],
					"commonrightbtn": [],
					"commonbottombtn":[],
        },
      activity_id: this.$route.query.id, // 活动id
      tableTitle: [],
      tableData: [],
      picBig: '',
      getPicBig: false,
      playIcon: true,
      videofid: '',
      total: 0,
			currentPage: 1, // 初始页
      pageSize: 10 // 每页数据量
    }
  },
  computed: {
		swiper() {
			return this.$refs.mySwiper.$swiper
		}
	},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.querySignupList()
  },
  // 方法集合
  methods: {
    querySignupList () {
      let data = {
        activity_id: this.activity_id,
        access_token: localStorage.getItem("access_token"),
        page: this.currentPage,
        limit: this.pageSize
      }
      this.api.getSignInfoList(data).then(res => {
        if (!res) return
        this.tableTitle = res.tableTitle
        this.tableTitle.unshift('用户id','用户头像','用户昵称')

        res.data.forEach(item => {
          let obj = {}
          item.appendInfos.forEach(item => {
            obj[item.title] = {
              title: item.title,
              name: item.fileName,
              url: item.url,
              type: item.limitType
            }
          })
          item['用户头像'] = item.avatar
          item['用户id'] = item.openId
          item['用户昵称'] = item.username
          item = Object.assign(item, obj)
        })
        this.tableData = res.data
       
        this.total = res.total
      })
    },
    gePicUrl (url) {
      this.picBig = url
      this.getPicBig = !this.getPicBig
    },
    showvideo(fid){
      if(this.videofid){
        document.getElementById(this.videofid).pause();
      }
      this.videofid = fid;
      document.getElementById(fid).play();
    },
    // 单文件下载
    async download(url, name) {
      const fileUtils = new FileUtils(url, name)
      await fileUtils.readUrl()
      await fileUtils.download()
    },
    // 每页显示条数
		handleSizeChange (val) {
			this.pageSize = val
			this.querySignupList()
		},
		// 选择当前页数
		handleCurrentChange (val) {
			this.currentPage = val
			this.querySignupList()
    }
  }
}
</script>

<style lang='scss' scoped>
.signup-info {
  .container {
    overflow-x: auto;
  }
  .signup-info-table {
    padding: 0 10px;
    text-align: left;
    background-color: #fff;
    tr, td {
      color: #909399;
      border-bottom: 1px solid #f0f2f5;
      white-space: nowrap;
    }
    tr th {
      height: 50px;
      line-height: 50px;
      margin-bottom: 5px;
      border-bottom: 5px solid #f0f2f5;
    }
    .user-pic {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      overflow: hidden;
    }
    .pic-title {
      width: 100px;
      height: 60px;
      border-radius: 4px;
      overflow: hidden;
      cursor: pointer;
    }
    .text-title {
      margin-right: 15px;
    }
    .file-title {
      margin-right: 15px;
      cursor: pointer;
    }
    .video-title {
      width: 150px;
      height: auto;
      margin-right: 15px;
      padding: 6px 0;
      border-radius: 6px;
      overflow: hidden;
    }
  }
  .pic-big {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 99;
    width: 100vw;
    height: 100vh;
    .mask {
      background-color: rgba(0, 0, 0, 0.6);
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      width: 100%;
      height: 100%;
      z-index: 99;
    }
    .pic-big-review {
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 999;
      transform: translate(-50%, -50%);
      max-width: 100%;
      max-height: 100%;
    }
  }
  .toolbar-pages {
    position: relative;
    text-align: right;
    background-color: #f0f2f5;
    margin: 0 -20px;
    .total-num {
      position: absolute;
      left: 20px;
      bottom: 10px;
      z-index: 9;
    }
  }
}
</style>